import React from 'react'
import Login from '../Modules/SignupModule/Login';
import Header from '../Modules/Components/Header';
import Footer from '../Modules/Components/Footer';

const Log = () => {
  return (
    <>
    <Header/>
    <Login></Login>
    <Footer/>
    </>
  )
}

export default Log